import { CardModel as CardModelBase } from '../card.model';

export class CardModel extends CardModelBase {
    public payload: any;
    public installments: number;
    public amount: number;
    public currency: string;
    public expiration_month: string;
    public expiration_year: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/models/payment/card.model.ts